import moment from 'moment';

const IsDateInPast = (date) => {
  if (!date) {
    return null;
  }

  const today = moment();
  const momentDate = moment(date);

  return today > momentDate;
};

const getCurrentTimeZone = () => new Date()
  .toLocaleTimeString('en-Us', {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short',
  }).substring(6);

const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
const dateFormat = 'YYYY-MM-DD';
const monthFormat = 'YYYY-MM';

export default {
  IsDateInPast,
  getCurrentTimeZone,
  dateTimeFormat,
  dateFormat,
  monthFormat,
};
